<template>
    
    <span class="woocommerce-Price-amount amount">{{ formatRate(rate) }}</span>

</template>

<script>

export default {

    props: {
        rate: Number
    },

    methods: {

        formatRate: function(rate) {
            return rate + '%'
        }
    }
}
</script>